import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WebStoriesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"web_stories"}/>
}
